import { spin } from "@styles";
import styled from "styled-components";

interface FormLoadingSpinnerProps {
  size?: string;
}

export const FormLoadingSpinner = ({ size }: FormLoadingSpinnerProps) => {
  return (
    <LoadingSpinner size={size}>
      <svg viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          opacity="0.4"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15 27C21.6274 27 27 21.6274 27 15C27 8.37256 21.6274 2.99998 15 2.99998C8.37259 2.99998 3 8.37256 3 15C3 21.6274 8.37259 27 15 27ZM15 29.6666C23.1002 29.6666 29.6667 23.1002 29.6667 15C29.6667 6.8998 23.1002 0.333313 15 0.333313C6.89983 0.333313 0.333336 6.8998 0.333336 15C0.333336 23.1002 6.89983 29.6666 15 29.6666Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1.76891 12.3372C2.50312 12.3937 3.05253 13.0347 2.99605 13.7689C2.3921 21.6203 8.37965 27.6079 16.2311 27.0039C16.9653 26.9474 17.6062 27.4968 17.6627 28.2311C17.7192 28.9653 17.1698 29.6062 16.4356 29.6627C6.95367 30.3921 -0.392138 23.0463 0.337241 13.5644C0.393719 12.8302 1.0347 12.2808 1.76891 12.3372Z"
          fill="white"
        />
      </svg>
    </LoadingSpinner>
  );
};

const LoadingSpinner = styled.div<{ size?: string }>`
  width: ${(p) => p.size ?? "30px"};
  height: ${(p) => p.size ?? "30px"};
  animation: ${spin} 2s linear infinite;
  z-index: 5;
  display: flex;
  pointer-events: none;
  align-items: center;
  justify-content: center;
  margin-right: 0.5rem;
`;
